import Helper from '@ember/component/helper';

const INDICATORS = {
  paused: 'fly-indicator fly-indicator--warning',
  inactive: 'fly-indicator fly-indicator--danger',
  draft: 'fly-indicator fly-indicator--warning',
  off: 'fly-indicator fly-indicator--danger',
};

const NO_INDICATOR_ACTION_TYPES = ['static_seg_update_action', 'collection_query_action'];

export function actionIcon([action]) {
  let indicator;

  if (NO_INDICATOR_ACTION_TYPES.includes(action.type)) {
    return '';
  } else if (action.get('isSplitTest')) {
    indicator = INDICATORS[action.get('splitState')];
  } else if (action.get('isMessaging')) {
    indicator = INDICATORS[action.get('sendingState')];
  }

  return `${indicator || ''}`.trim();
}

export default Helper.helper(actionIcon);
